import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { BoolFilter } from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export const LocationTabs = {
  GENERAL: "general",
  INTEGRATIONS: "integrations",
} as const
export type LocationTab = (typeof LocationTabs)[keyof typeof LocationTabs]

export function adminLocations(): WebUrl {
  return {
    pathname: "/admin/locations",
    query: { status: BoolFilter.TRUE.toString() },
  }
}

export function adminLocation(id?: PBUUID, tab?: LocationTab): WebUrl {
  return {
    pathname: `/admin/locations/${UUID.idString(id)}/${tab ?? LocationTabs.GENERAL}`,
    query: {},
  }
}
